import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { listEventUsers, setEventUsers } from '@/lib/api/eventUsers';

const KEYS = {
  all: ['event-users'] as const,
  byEvent: (eventId: string) => [...KEYS.all, eventId] as const,
};

export const useEventUsers = (eventId: string | null | undefined) =>
  useQuery({
    queryKey: KEYS.byEvent(eventId ?? ''),
    queryFn: () => listEventUsers(eventId!),
    enabled: !!eventId,
  });

export const useSetEventUsers = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (a: { eventId: string; userIds: string[] }) => setEventUsers(a.eventId, a.userIds),
    onSuccess: (_, a) => {
      qc.invalidateQueries({ queryKey: KEYS.byEvent(a.eventId) });
      // The restricted user's event list changes too.
      qc.invalidateQueries({ queryKey: ['events'] });
    },
  });
};
